export default __webpack_public_path__ + "static/media/img-0315-madagascar-full-face.22a20e80.png";